"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchResultsGridSection = exports.showContestError = exports.setNewResults = void 0;
var OnlineOfflineMode_1 = require("icf-search-client-shared/lib/constants/OnlineOfflineMode");
var RecommenderSession_1 = require("icf-search-client-shared/lib/services/RecommenderSession");
var XmentService_1 = require("icf-search-client-shared/lib/services/XmentService");
var react_1 = __importStar(require("react"));
var Contexts_1 = require("../Contexts");
var Ioc_1 = require("../utilities/Ioc");
var ContestLogin_1 = require("./ContestLogin");
var ContestResultsError_1 = require("./ContestResultsError");
var HeroSpaceGridCard_1 = require("./HeroSpaceGridCard");
var PerformerItemContainer_1 = require("./PerformerItemContainer");
var PerformerList_1 = require("./PerformerList");
var SearchResultsError_1 = require("./SearchResultsError");
var SearchResultsGridHelpers_1 = require("./SearchResultsGridHelpers");
var MAX_GRID_CLICKS = 100;
var GRID_CLICKS_STORAGE_KEY = "gridClicks";
var newResults = false;
var setNewResults = function (newResult) {
    newResults = newResult;
};
exports.setNewResults = setNewResults;
var gridClicksMap = new Map();
var appendNewGridClick = function (performerId) {
    if (gridClicksMap.has(performerId)) {
        gridClicksMap.delete(performerId);
    }
    gridClicksMap.set(performerId, true);
    var oldest = gridClicksMap.keys().next().value;
    if (gridClicksMap.size > MAX_GRID_CLICKS && oldest) {
        gridClicksMap.delete(oldest);
    }
};
(function initializeFromStorage() {
    var e_1, _a;
    var previousGridClicks = sessionStorage.getItem(GRID_CLICKS_STORAGE_KEY);
    if (previousGridClicks) {
        try {
            for (var _b = __values(previousGridClicks.split(",")), _c = _b.next(); !_c.done; _c = _b.next()) {
                var performerId = _c.value;
                appendNewGridClick(performerId);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
})();
var breakpointColumnGutters = {
    small: 2,
    medium: 2,
    large: 4,
};
var showContestError = function (queryOptions, resultsContext) {
    if (queryOptions.type !== "contest") {
        return false;
    }
    else if (!queryOptions.contestInfo) {
        return true;
        // Was this written as if this was observable?
    }
    else if (!(resultsContext === null || resultsContext === void 0 ? void 0 : resultsContext.value)) {
        return true;
    }
    else if (resultsContext.value.isLoadingInitialResults) {
        return false;
    }
    else if (resultsContext.value.totalItemCount === 0 || resultsContext.value.isFallback) {
        return true;
    }
    return false;
};
exports.showContestError = showContestError;
var SearchResultsGridSection = function (_a) {
    var breakpoint = _a.breakpoint, currentCategory = _a.currentCategory, dataSource = _a.dataSource, emitTrackingEvent = _a.emitTrackingEvent, heroBannerImage = _a.heroBannerImage, isFirstGrid = _a.isFirstGrid, isLogoVerified = _a.isLogoVerified, isSoundEnabled = _a.isSoundEnabled, logger = _a.logger, navigation = _a.navigation, onJoinClicked = _a.onJoinClicked, onLoginClicked = _a.onLoginClicked, onlineOfflineMode = _a.onlineOfflineMode, onOfflineButtonClicked = _a.onOfflineButtonClicked, onNotifyClicked = _a.onNotifyClicked, openJoinModal = _a.openJoinModal, queryOptions = _a.queryOptions, setIsGridErrored = _a.setIsGridErrored, showHeadlines = _a.showHeadlines, statsdClient = _a.statsdClient, thumbnailSize = _a.thumbnailSize, translate = _a.translate, user = _a.user, xmentService = _a.xmentService, onNoOnlineResultsRedirect = _a.onNoOnlineResultsRedirect, pushRoute = _a.pushRoute;
    var _b = __read((0, Ioc_1.useContexts)(Contexts_1.IRouterContext), 1), router = _b[0];
    var isHeroBannerOnGrid = currentCategory === "allgirls" && (xmentService === null || xmentService === void 0 ? void 0 : xmentService.isXmentVariationOn(XmentService_1.SEARCH_FREE_ACCOUNT_SIGN_UP_TILE_XMENT_NAME));
    if (queryOptions.type === "contest") {
        statsdClient.count("searchResults.view_contest_total");
        if (!user || !user.isAuthenticated) {
            return react_1.default.createElement(ContestLogin_1.ContestLogin, { onLoginClicked: onLoginClicked, onJoinClicked: onJoinClicked, translate: translate });
        }
        else if ((0, exports.showContestError)(queryOptions, dataSource.resultsContext)) {
            statsdClient.count("searchResults.view_contest_error");
            return react_1.default.createElement(ContestResultsError_1.ContestResultsError, { translate: translate, onTryAgainClicked: function () { return dataSource.reset(); } });
        }
    }
    if (user && user.country) {
        queryOptions.country = user.country;
    }
    if (navigation && navigation.path === "/view/recents" && statsdClient) {
        statsdClient.count("searchResults.view_recents_total");
    }
    if (!(0, SearchResultsGridHelpers_1.shouldShowPerformerGrid)(dataSource.resultsContext.value.errors)) {
        return react_1.default.createElement("div", null);
    }
    if (dataSource.resultsContext.value.currentError) {
        logger && logger.error("Failed to get search results", dataSource.resultsContext.value.currentError);
        addStatsdForErrors(queryOptions, navigation, statsdClient);
        setIsGridErrored && setIsGridErrored(true);
        return react_1.default.createElement(SearchResultsError_1.SearchResultsError, { onTryAgainClicked: function () { return dataSource.reset(); }, translate: translate });
    }
    setIsGridErrored && setIsGridErrored(false);
    var currentPerformerItem = (0, react_1.useRef)(null);
    var onGridClick = function (performerId) {
        var previousLastGridClick = sessionStorage.getItem("lastGridClick");
        (0, exports.setNewResults)(previousLastGridClick !== performerId);
        sessionStorage.setItem("lastGridClick", performerId);
        appendNewGridClick(performerId);
        sessionStorage.setItem(GRID_CLICKS_STORAGE_KEY, Array.from(gridClicksMap.keys()).join(","));
    };
    (0, react_1.useEffect)(function () {
        dataSource.resultsContext.subscribe(function () {
            var _a, _b;
            var resultsContext = dataSource.resultsContext.value;
            var filters = queryOptions.filters;
            var pathname = (_a = router === null || router === void 0 ? void 0 : router.location) === null || _a === void 0 ? void 0 : _a.pathname;
            var isHomePage = [
                "/",
                "/browse/livesex/allgirls",
                "/browse/guycams/allguys",
                "/browse/transcams/alltrans",
                "/page/1",
                "/browse/livesex/allgirls/page/1",
                "/browse/guycams/allguys/page/1",
                "/browse/transcams/alltrans/page/1",
            ].includes(pathname);
            var isUnfilteredHomepage = ((_b = filters === null || filters === void 0 ? void 0 : filters.advanced) === null || _b === void 0 ? void 0 : _b.every(function (filter) { return filter.options.every(function (option) { return !option.isChecked; }); })) && isHomePage;
            var isOnlineOnlyDisabledPage = queryOptions.type === "favorites" || queryOptions.type === "contest";
            if (resultsContext.isFallback &&
                onlineOfflineMode === OnlineOfflineMode_1.ONLINE_OFFLINE_MODE_ONLINE &&
                onOfflineButtonClicked &&
                !isUnfilteredHomepage &&
                !isOnlineOnlyDisabledPage &&
                !dataSource.resultsContext.value.isLoadingInitialResults) {
                onOfflineButtonClicked();
                onNoOnlineResultsRedirect === null || onNoOnlineResultsRedirect === void 0 ? void 0 : onNoOnlineResultsRedirect();
            }
            var experimentName = (0, RecommenderSession_1.getRecommenderSession)().experimentName;
            if (!isHomePage && experimentName && experimentName.startsWith("lastGridClick") && newResults && pushRoute) {
                var newPage = pathname.split("/page")[0];
                pushRoute(newPage);
            }
            (0, exports.setNewResults)(false);
        });
    }, []);
    // TODO: This shouldn't be an issue because the item should never be unmounted and remounted while the user is hovering over it
    var swapRollovers = function (newPerformerItem) {
        // Only stop the rollover if the new performerItem is different than the last (important for compatibility with desktop)
        if ((currentPerformerItem === null || currentPerformerItem === void 0 ? void 0 : currentPerformerItem.current) &&
            currentPerformerItem.current.getPerformerId() !== newPerformerItem.getPerformerId()) {
            currentPerformerItem.current.stopRollover();
        }
        currentPerformerItem.current = newPerformerItem;
    };
    return (react_1.default.createElement(PerformerList_1.PerformerList, { dataSource: dataSource, layout: __assign(__assign({ type: "optimalWidthGrid" }, (0, SearchResultsGridHelpers_1.getWidthAndColumns)(thumbnailSize)), { cellRatio: 3 / 4, gutter: breakpointColumnGutters[breakpoint] }), itemRenderer: function (performerData, itemIndex) {
            if (isHeroBannerOnGrid &&
                itemIndex === 5 &&
                breakpoint !== "large" &&
                dataSource.itemRange.value.start === 0 &&
                isFirstGrid &&
                !user.isAuthenticated) {
                return react_1.default.createElement(HeroSpaceGridCard_1.HeroSpaceGridCard, { heroBannerImage: heroBannerImage });
            }
            return (react_1.default.createElement(PerformerItemContainer_1.PerformerItemContainer, { breakpoint: breakpoint, dataSource: dataSource, dataQueryOptions: queryOptions, emitTrackingEvent: emitTrackingEvent, getPerformerLinkTo: navigation.getPerformerLinkTo, isLogoVerified: isLogoVerified, isMobile: breakpoint !== "large", itemIndex: itemIndex, isSoundEnabled: isSoundEnabled, key: "performerItem" + itemIndex, onNotifyClicked: onNotifyClicked, openJoinModal: openJoinModal, performerData: performerData, showHeadlines: showHeadlines, swapRollovers: swapRollovers, onGridClick: onGridClick }));
        } }));
};
exports.SearchResultsGridSection = SearchResultsGridSection;
// TODO: Typings
function addStatsdForErrors(queryOptions, navigation, statsdClient) {
    if (!statsdClient) {
        return;
    }
    statsdClient.count("searchResults.data_source_failed");
    if (queryOptions && queryOptions.type === "contest") {
        statsdClient.count("searchResults.view_contest_failed");
    }
    if (navigation && navigation.path === "/view/recents") {
        statsdClient.count("searchResults.view_recents_failed");
    }
}
exports.SearchResultsGridSection.displayName = "SearchResultsGridSection";
//# sourceMappingURL=SearchResultsGridSection.js.map